"use strict";

// Плашка с важным сообщением наверху страницы.

import dom from "../dom";
import storage from "../storage";

class AttentionPanel extends HTMLElement {
    connectedCallback() {
        if (storage.has(this.messageId)) {
            return;
        }
        this.render();
        this.listen();
        this.show();
    }

    render() {
        const content = this.innerHTML;
        this.innerHTML = `<div class="storey attention">
                            ${content}
                            <a href="#" class="attention__close">
                                <i class="fa fa-close"></i>
                            </a>
                        </div>`;
    }

    listen() {
        const linkEl = this.querySelectorAll("a");
        linkEl.forEach((el) => {
            el.addEventListener("click", () => {
                storage.set(this.messageId, "seen");
                this.hide();
            });
        });
    }

    show() {
        dom.show(this);
    }

    hide() {
        this.style.opacity = 0;
        this.style.visibility = "hidden";
        setTimeout(() => {
            dom.hide(this);
        }, 200);
    }

    get messageId() {
        return `attention:${this.getAttribute("message")}`;
    }
}

customElements.define("attention-panel", AttentionPanel);

export default {};
